import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../shared/services/user/user.service';
import { ResetPasswordModel } from '../../../model/ResetPasswordModel';
import { NotificationService } from '../../../shared/services/notification.service';
import { areEqual } from '../../../validators/validators';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LoadingContainer, LoadingPage } from '../../../shared/LoadingContainer';

import { TranslatorService } from '../../../core/translator/translator.service';

import { AppSettingsService } from '../../../shared/services/appsettings.service';

@Component({
    selector: 'app-userresetpassword',
    template: require('./resetpassword.component.html'),
    //styles: [require('./lostpassword.component.scss')]
})
export class ResetPasswordComponent extends LoadingPage {
    valForm: FormGroup;
    model = new ResetPasswordModel();

    constructor(private userService: UserService,
        public settings: AppSettingsService,
        private route: ActivatedRoute,
        private router: Router,
        protected notificationService: NotificationService,
        private fb: FormBuilder,
        private translateService: TranslatorService) {
        super(true);
        this.valForm = fb.group({
            'password': [null, [Validators.required, Validators.minLength(6)]],
            'passwordConfirm': [null, Validators.required]
        },
            { validator: areEqual('password', 'passwordConfirm') });
    }

    ngOnInit() {
        this.standby();
        this.model.UserId = this.route.snapshot.params['id'];
        this.model.ResetCode = this.route.snapshot.params['resetCode'];
        this.ready();
    }


    private resetPw(event: any) {
     
  
    }

    submitForm($ev: Event, value: any) {
        console.log(this.valForm);
        this.standby();
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }

        if (!this.valForm.valid) {
            this.ready();
            this.notificationService.showWarning('app.notification.WARNING', 'app.notification.VALIDATION_FAILED');
            return;
        }     

        this.model.Password = btoa(this.model.Password);
        this.model.ConfirmPassword = btoa(this.model.ConfirmPassword);

        this.userService.resetPassword(this.model).then(response => {
            this.ready();
            this.model = new ResetPasswordModel();
            this.notificationService.showSuccess('app.notification.SUCCESS', response.message);
            setTimeout(() => { this.router.navigate(['/login']); }, 5000);
        }).catch(e => {
            this.ready();
            this.model = new ResetPasswordModel();
            this.notificationService.showError('app.notification.ERROR', 'reset.notification.ERROR_RESET');
            console.error('Error', e);
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/pages/recover/resetpassword.component.ts